export const CowMark = ({ size = 36 }) => (
  <img
    src="/mascots/solmoo-logo.png"
    alt="SOLMOO logo"
    width={size}
    height={size}
    className="rounded-xl object-cover"
  />
);
